import { render, staticRenderFns } from "./ProducersTableAccount.vue?vue&type=template&id=3a43ba95&"
import script from "./ProducersTableAccount.vue?vue&type=script&lang=js&"
export * from "./ProducersTableAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports